import { Component } from '@angular/core'

@Component({
  standalone: false,
  templateUrl: './404.component.html',
  styleUrls: ['./404.component.scss'],
})
export class FourOhFourComponent {}
